;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { queryOptions } from '@tanstack/react-query'

import { browserCanaryClient } from './browser-canary-client'

// Only terms between 3 and 50 characters are sent to the search
const SEARCH_TERM_MIN_LENGTH = 3
const SEARCH_TERM_MAX_LENGTH = 50

export function isValidSearchTerm(searchTerm: string) {
  const length = searchTerm.trim().length
  return length >= SEARCH_TERM_MIN_LENGTH && length <= SEARCH_TERM_MAX_LENGTH
}

export function isSearchTermTooShort(searchTerm: string) {
  const length = searchTerm.trim().length
  return length > 0 && length < SEARCH_TERM_MIN_LENGTH
}

export function salesSearchQueryOptions({
  searchTerm,
}: {
  searchTerm: string
}) {
  return queryOptions({
    queryKey: ['sales-search', { searchTerm }],
    queryFn: () => {
      return browserCanaryClient.getSalesSearch(searchTerm)
    },
    enabled: isValidSearchTerm(searchTerm),
  })
}
